import a from "./_getTag.js";
import r from "./isObjectLike.js";
var e = "[object Map]";
function i(t) {
  return r(t) && a(t) == e;
}
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseIsMap.js
// module id = 1430
// module chunks = 41